/**
 * @generated SignedSource<<cb2e532f0c4f6f78666df5cc28c59435>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutLayout_transaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutFooter_transaction" | "CheckoutMobileSummaryPane_transaction" | "CheckoutSidebar_transaction" | "CheckoutSteps_transaction">;
  readonly " $fragmentType": "CheckoutLayout_transaction";
};
export type CheckoutLayout_transaction$key = {
  readonly " $data"?: CheckoutLayout_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutLayout_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutLayout_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryPane_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebar_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutFooter_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSteps_transaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "263e42cec71ab5e34bb53b12bb37bc22";

export default node;
